var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Card',{attrs:{"title":"greeting-expired"}},[_c('InfoUser',{attrs:{"data":_vm.userDetails}}),_c('PaymentDetail',{attrs:{"isVertical":"true","data":_vm.paymentDetail}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }